import '@/assets.v2/css/style.scss'
import { initPageSiteV2, onPageLoad } from './init'

initPageSiteV2()
document.addEventListener('DOMContentLoaded', function () {
  onPageLoad()
})
